import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "card custom-card custom-card-padding" }
const _hoisted_3 = { class: "is-flex-direction-column is-align-items-center is-justify-content-space-between" }
const _hoisted_4 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_5 = { class: "modal-card" }
const _hoisted_6 = { class: "modal-card-head" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title is-title-shrink" }, " Toutes les opérations ", -1)
const _hoisted_8 = { class: "modal-card-body custom-card-transactions" }
const _hoisted_9 = { class: "custom-card is-flex-direction-column is-align-items-center is-justify-content-space-between mb-4" }
const _hoisted_10 = { class: "modal-card-foot custom-modal-card-foot" }
const _hoisted_11 = { class: "transactions-loader-container" }
const _hoisted_12 = {
  key: 1,
  class: "has-text-centered mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThisWeek = _resolveComponent("ThisWeek")!
  const _component_AllTrs = _resolveComponent("AllTrs")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ThisWeek)
      ]),
      (_ctx.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "modal-background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false))
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("header", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("button", {
                  class: "delete",
                  "aria-label": "close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {
                ;(_ctx.showModal = false), (_ctx.showCreditRefreshNotification = false)
              })
                })
              ]),
              _createElementVNode("section", _hoisted_8, [
                _createElementVNode("div", {
                  class: "modal-container custom-modal-container",
                  ref: "transactionsContainer",
                  onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_AllTrs)
                  ])
                ], 544)
              ]),
              _createElementVNode("footer", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_loading, {
                    active: _ctx.isLoadingTransactionsBatch,
                    "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isLoadingTransactionsBatch) = $event)),
                    "can-cancel": false,
                    "is-full-page": false,
                    width: 30,
                    height: 30
                  }, null, 8, ["active"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoadingTransactions && _ctx.getTrs?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = true)),
              class: "button custom-button custom-inverted"
            }, " Voir tout ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}